import axios from "axios"
import {NEWS_URL} from "../globals"
// import {createQueryParams} from "../helpers/utils"
import {handleError} from "../helpers/errors"
import {generateCRUDUrls, generateFinalUrl} from "./utils"

const URL = {
  NEWS: generateCRUDUrls("/news"),
  NEWS_LIST_ADMIN: "/news/admin/list/",
  NEWS_LIST_TEN: "/news/list-top-10/",
  NEWS_UPDATE_USER_VIEWED: "/news/set-user-viewed-news/",
  NEWS_LIST: "/news/list-users-news/"
}

const generateCommonHeader = (authToken) => {
  return {
    Authorization: `Bearer ${authToken}`,
  }
}

const axiosInstance = axios.create({
  baseURL: NEWS_URL,
})
axiosInstance.interceptors.response.use(null, handleError)


//News CRUD
export const listNews = (authToken) => {
  const url = generateFinalUrl(URL.NEWS.LIST)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createNews = (authToken, newsData) => {
  const url = generateFinalUrl(URL.NEWS.CREATE)
  return axiosInstance.post(url,
    newsData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const updateNews = (authToken, pk, newsData) => {
  const url = generateFinalUrl(URL.NEWS.UPDATE, pk)
  return axiosInstance.put(url,
    newsData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const deleteNews = (authToken, pk) => {
  const url = generateFinalUrl(URL.NEWS.DELETE, pk)
  return axiosInstance.delete(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listAdminNews = (authToken) => {
  return axiosInstance.get(URL.NEWS_LIST_ADMIN,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

//-------------------------------------------------

export const listNewsTen = (authToken) => {
  const url = generateFinalUrl(URL.NEWS_LIST_TEN)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const updateUserViewedNews = (authToken, updateData) => {
  const url = generateFinalUrl(URL.NEWS_UPDATE_USER_VIEWED)
  return axiosInstance.post(url,
    updateData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const listNewsUsers = (authToken) => {
  const url = generateFinalUrl(URL.NEWS_LIST)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}